import design from '@design'

export const eventColorsMixin = {
  methods: {
    getEventColorClass(eventType) {
      const colorClasses = {
        'Network Event': 'calendar-blue',
        'Industry Events': 'calendar-green',
        'Prof. Development/Education': 'calendar-orange',
        'Support Closure': 'calendar-gray',
        'Onboarding and Implementation': 'calendar-dark-blue',
        'Internal Event': 'calendar-slate',
        'Communication Calendar': 'calendar-red',
      }

      return colorClasses[eventType]
    },

    getEventColorHex(eventType) {
      const colorHexes = {
        'Network Event': design['secondary-light-blue'],
        'Industry Events': design['secondary-green'],
        'Prof. Development/Education': design['secondary-orange'],
        'Support Closure': design['dark-gray'],
        'Onboarding and Implementation': design['primary-blue'],
        'Internal Event': design['primary-slate'],
        'Communication Calendar': design['secondary-red'],
      }

      return colorHexes[eventType]
    },
  },
}
